import type React from 'react'
import styled from 'styled-components'

import { ItemHeader } from '@/components/Style/Common'
import DateStringInput from '@/components/TextInput'
import type { SelfEmploymentIncome } from '@/types/AddIncome'

import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'
import IncomePropertiesInput from './IncomePropertiesInput'

const DateField = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px 5px;
`

interface Props {
  income: SelfEmploymentIncome
  propertyDispatch: PropertyDispatch
}

const SelfEmployedIncomeInput: React.FC<Props> = ({ income, propertyDispatch }) => {
  return (
    <>
      <ItemHeader>When did the self-employment start?</ItemHeader>
      <DateField>
        <DateStringInput
          placeholder="dd/mm/yyyy"
          name="startDate"
          type="date"
          value={income.startDate}
          onChange={value => propertyDispatch.set(Property.StartDate, value)}
        />
      </DateField>
      <IncomePropertiesInput
        incomeProperties={income.incomeProperties}
        propertyDispatch={propertyDispatch}
        amountProperty={Property.IncomeAmount}
        frequencyProperty={Property.IncomeFrequency}
        hourlyProperty={Property.IncomeHoursPerWeek}
      />
    </>
  )
}

export default SelfEmployedIncomeInput
